/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the event date
 *   * TYPE : the event type
 *   * SUBTYPE : the event type
 *   * CONNECTION_TYPE : the related connection type
 *   * CONNECTION_NAME : the related connection name
 */
export enum AgentEventSortFieldName {
  DATE = 'DATE',
  TYPE = 'TYPE',
  SUBTYPE = 'SUBTYPE',
  CONNECTION_TYPE = 'CONNECTION_TYPE',
  CONNECTION_NAME = 'CONNECTION_NAME'
}
